import React, { FC } from "react";
import { DefaultButton, StyledAnchorLink } from "../../buttons/default.style";
import {
    ReviewHeader,
    ReviewHeaderDate,
    ReviewText,
    Card,
    ReviewFooter,
    ReviewLogo,
} from "./style";

type ReviewCardProps = {
    image: string;
    link: string;
    text?: string;
};

const ProductCard: FC<ReviewCardProps> = ({ image, link, text }) => (
    <Card>
        <img loading='lazy' src={`${process.env.PUBLIC_URL}/${image}`} alt='header-photo' />
        <ReviewText>{text}</ReviewText>
        <ReviewFooter>
            <StyledAnchorLink to={link}>Learn more</StyledAnchorLink>
        </ReviewFooter>
    </Card>
);

export default ProductCard;
